import React from 'react';

import { ContentTypesType } from 'components/ContentTypeList/types';
import { getCMSLink, getLink, linkText } from 'modules/utils/utils';
import BookmarkItem from 'components/BookMarkItem';

import styles from './styles.module.scss';
import { SocialMediaCard } from 'components/CMSModals/socialMediaCard';

type BookmarksFullWidthProps = {
  bookmarks: any[];
  handleBookmarkClick: (contentTypeUid: string) => void;
};

const BookmarksFullWidth: React.FunctionComponent<BookmarksFullWidthProps> = ({
  handleBookmarkClick,
  bookmarks,
}) => {
  return bookmarks?.length > 3 ? (
    <React.Fragment>
      <div className={styles.fullWidth}>
        {bookmarks.slice(3).map((bookmark: SocialMediaCard, index: number) => (
          <BookmarkItem
            handleBookmarkClick={handleBookmarkClick}
            bookmarked={bookmark.isSaved}
            buttonLabel={linkText(bookmark.navText)}
            description={bookmark.description}
            image={bookmark?.imageUrl}
            key={`content-types-${index}`}
            liked={bookmark.isLiked}
            likes={bookmark.likeCount}
            publicationDate={bookmark.publicationDate.toString()}
            slug={getCMSLink(bookmark.navLink)}
            title={bookmark.title}
            uid={bookmark.rowKey}
          />
        ))}
      </div>
    </React.Fragment>
  ) : null;
};

export default BookmarksFullWidth;
